import { createMergedBlockSelector } from "../../selectors";
import { getArticlesBlock } from "../selectors";
var getArticlesData = createMergedBlockSelector(getArticlesBlock);
export var getArticlesTitle = function getArticlesTitle(state) {
  return getArticlesData(state).title;
};
export var getArticlesSubTitle = function getArticlesSubTitle(state) {
  return getArticlesData(state).subTitle;
};
export var getArticlesSubTitleLink = function getArticlesSubTitleLink(state) {
  return getArticlesData(state).subTitleLink;
};
export var getArticlesCardsList = function getArticlesCardsList(state) {
  return getArticlesData(state).items;
};